export enum ConsumerStatus {
  None = 'none',
  GatheringInfo = 'gathering_patient_info',
  OngoingSupport = 'ongoing_support',
  PatientUnreachable = 'unreachable',
  UnableToEngage = 'unable_to_engage',
  Done = 'done',
}
